import Apprenti from '@/generated/classes/Apprenti';
export default class ApprentiExtend extends Apprenti {
  constructor() {
    super();
  }
}
